<template>
    <div style="height: 21px; float: right;">
        <base-button size="sm" type="primary" class=" mb-3" @click="modal = true" icon="ni ni-fat-add">
        </base-button>

        <modal :show.sync="modal"
               body-classes="p-0"
               modal-classes="modal-dialog-centered modal-sm">
            <card type="secondary" shadow
                  header-classes="bg-white pb-5"
                  body-classes="px-lg-5 py-lg-5"
                  class="border-0">
                <template>
                    <div class="text-center text-muted mb-4">
                        <small>Spielerschutzmaßnahme anlegen</small>
                    </div>
                    <div class="text-center">
                    <form role="form" @submit.prevent="addActivity">
                        <label v-if="!$store.getters['authentication/isService']" class="form-control-label">
                            Standort
                            <span>*</span></label>
                        <select v-if="!$store.getters['authentication/isService']"  v-model="data.location"
                                 class="mb-1 custom-select form-control">
                            <option :value="null" selected disabled>Standort auswählen</option>
                            <option v-for="location in $store.getters['location/showLocationCollection']" :key="location.id" :value="location['@id']">{{ location.name }}
                            </option>
                        </select>
                        <label v-if="data.location !== null && !$store.getters['authentication/isService']" class="form-control-label">
                            Benutzer
                            <span>*</span></label>
                        <select v-if="data.location !== null && !$store.getters['authentication/isService']" v-model="user"
                                class="mb-1 custom-select form-control">
                            <option :value="null" selected disabled>Benutzer auswählen</option>
                            <option v-for="user in $store.getters['location/showLocationByIRI'](data.location).users" :key="user.id" :value="user">{{ user.firstname+" "+user.lastname }}
                            </option>
                        </select>
                        <label v-if="user !== null" class="form-control-label">
                            Profil
                            <span>*</span></label>
                        <select v-if="user !== null" v-model="data.profile"
                                class="mb-1 custom-select form-control">
                            <option :value="null" selected disabled>Profil auswählen</option>
                            <option v-for="profile in $store.getters['profiles/showProfilesByUser'](user.id)" :key="profile.id" :value="profile['@id']">{{ profile.name }}
                            </option>
                        </select>
                        <label class="form-control-label">
                            Status
                            <span>*</span></label>
                        <select v-model="data.action"
                                class="mb-1 custom-select form-control">
                            <option v-for="action in getActionCollection" :key="action.id" :value="action['@id']">{{ action.name }}
                            </option>
                        </select>
                        <base-input v-model="data.comment"
                                    label="Kommentar"
                                    alternative
                                    type="text"
                                    placeholder="Kommentar">
                        </base-input>
                        <base-input
                            label="Erledigt Tag und Uhrzeit"
                            required
                            class="col-form-label"
                            placeholder="Datum&Uhrzeit der Durchführung">

                        <flat-pickr slot-scope="{focus, blur}"
                                    @on-open="focus"
                                    @on-close="blur"
                                    ref="pickr"
                                    :config="config"
                                    class="form-control form-control-alternative form-control-lg datepicker"
                                    v-model="data.doneAt">
                        </flat-pickr></base-input>
                        <div class="text-center">
                            <button class="btn btn-icon my-4 btn-primary" :disabled="isLoading" type="submit">
                                <span :key="key+'bcn11'" class="btn-inner--icon"><i v-if="isLoading" class="fas fa-circle-notch fa-spin"></i><i v-else class="ni ni-fat-add"></i></span>
                                <span class="btn-inner--text">speichern</span></button>
                            <base-button type="secondary" class="my-4" @click="modal = false">abbrechen</base-button>
                        </div>
                    </form>
                    </div>
                </template>
            </card>
        </modal>
    </div>
</template>

<script>
    import moment from 'moment-timezone'
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    import { German } from "flatpickr/dist/l10n/de.js";


    export default {
        name:"addactivity",
        components: {flatPickr},
        data() {
            return {
                modal: false,
                data: {
                    profile: null,
                    location: null,
                    action: null,
                    comment: '',
                    doneAt: new Date()
                },
                location: null,
                user: null,
                config: {
                    dateFormat: 'YYYY-MM-DDTHH:mm:ss',
                    altFormat: 'DD.MM.YYYY HH:mm',
                    enableTime: true,
                    time_24hr: true,
                    altInput: true,
                    allowInput: true,
                    locale: German,
                    parseDate(dateString, format) {
                        let timezonedDate = new moment.tz(dateString, format, 'Europe/Berlin');

                        return new Date(
                            timezonedDate.year(),
                            timezonedDate.month(),
                            timezonedDate.date(),
                            timezonedDate.hour(),
                            timezonedDate.minute(),
                            timezonedDate.second()
                        );
                    },
                    formatDate(date, format) {
                        let time;
                        if (format ==='YYYY-MM-DDTHH:mm:ss'){
                            time = moment.tz([
                                date.getFullYear(),
                                date.getMonth(),
                                date.getDate(),
                                date.getHours(),
                                date.getMinutes(),
                                date.getSeconds()
                            ], 'Europe/Berlin').utc().format();
                        } else {
                            time = moment.tz([
                                date.getFullYear(),
                                date.getMonth(),
                                date.getDate(),
                                date.getHours(),
                                date.getMinutes(),
                                date.getSeconds()
                            ], 'Europe/Berlin').locale('en-GB').format(format);
                        }

                        return time;
                    }
                },
                isLoading: false,
                key: 0
            }
        },
        created() {
            let promises = [this.$store.dispatch('actions/getActionCollection')];
          if(!this.$store.getters['location/isReady']) {
              promises.push(this.$store.dispatch('location/getLocationCollection'));
          }
          if(this.$store.getters['profiles/showActiveProfile'] === null && !this.$store.getters['profiles/isReady']) {
              promises.push(this.$store.dispatch('profiles/getProfiles'));
            }


          Promise.all(promises).then(() => {
              if (this.$store.getters['authentication/isService']) {
                  this.data.location = this.$store.getters['authentication/locationIRI'];
                  this.user = {
                      ['@id'] : this.$store.getters['authentication/iri'],
                      id : this.$store.getters['authentication/uid'],
                      firstname: this.$store.getters['authentication/uid'].firstname,
                      lastname: this.$store.getters['authentication/uid'].lastname
                  }
              }
          })

        },
        mounted() {
            this.key++
        },
        computed: {
            getActionCollection() {
                return this.$store.getters['actions/showActionCollection'];
            }
        },
        methods: {
            addActivity() {
                if (this.data.profile !== null) {
                    return new Promise((resolve, reject) => {
                        const header = this.authHeader();
                        header['Content-Type'] = 'application/json';
                        let senddata = this.data;
                        this.isLoading = true;
                        const requestOptions = {
                            method: 'POST',
                            headers: header,
                            body: JSON.stringify(senddata)
                        };
                        fetch(process.env.VUE_APP_API_SERVER + `/api/activities`, requestOptions)
                            .then(this.handleResponse)
                            .then(response => {
                                    resolve(response);
                                    this.modal = false;
                                    this.isLoading = false;
                                    this.data = {
                                        profile: null,
                                        action: null,
                                        location: null,
                                        comment: '',
                                        doneAt: new Date()
                                    };
                                    this.$store.dispatch('alert/success','Maßnahme erfolgreich angelegt');
                                },
                                error => {
                                    reject(error);
                                    this.isLoading = false;
                                    this.$store.dispatch('alert/error',error);
                                });
                    });
                } else {
                    this.$store.dispatch('alert/error','Bitte wählen Sie ein Profil (Standort -> Benutzer -> Profil) aus');
                }

            },
        }
    }
</script>

<style scoped>

</style>